import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTeamIndex } from '../../../../../store/user/user.action';
import { selectTeamIndex } from '../../../../../store/user/user.selector';

// styles
import {
    TeamSelectionContainer,
    TeamBar,
    ExpandedContent,
    TeamDisplay
} from './TeamSelection.styles';

// data
import { TEAM_LOGOS } from '../../../../../data/theme-data/team-data';
import { GRADIENT_DATA } from '../../../../../data/theme-data/gradient-data';

export default function TeamSelection() {
    const dispatch = useDispatch();
    const teamIndex = useSelector(selectTeamIndex);

    const [selectedTeamIndex, setSelectedTeamIndex] = useState(teamIndex || 0);

    // Handle team selection
    const handleTeamSelect = (teamIndex) => {
        setSelectedTeamIndex(teamIndex);
        dispatch(setTeamIndex(teamIndex));
    };

    // Get background style based on selected team
    const getBackgroundStyle = () => {
        const teamColors = GRADIENT_DATA[selectedTeamIndex];
        if (teamColors) {
            return {
                background: `linear-gradient(
                    135deg,
                    rgba(${teamColors[0]}, 0.4) 0%,
                    rgba(${teamColors[1]}, 0.4) 100%
                )`,
            };
        }
        return {};
    };

    return (
        <TeamSelectionContainer>
            <TeamBar className='panel-bg' style={getBackgroundStyle()}>
                <ExpandedContent>
                    {Object.keys(TEAM_LOGOS).map((key, index) => (
                        <TeamDisplay
                            key={index}
                            onClick={() => handleTeamSelect(index)}
                            className={index === selectedTeamIndex ? 'active' : ''}
                        >
                            <img
                                src={TEAM_LOGOS[key].logo}
                                alt={TEAM_LOGOS[key].name}
                                className={index === selectedTeamIndex ? 'active' : ''}
                            />
                        </TeamDisplay>
                    ))}
                </ExpandedContent>
            </TeamBar>
        </TeamSelectionContainer>
    );
}
